import { useDispatch } from "react-redux";
import Navbar from "../../../components/navbar/navbarComponent";
import { ActionCircleIcon } from "../../../components/icons/SvgIcons";
import { useForm } from "react-hook-form";
import { getAllUsers, getRegistro } from "../../../redux/actions";
import RegistroTableComponent from "./registroTable/registroTableComponent";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Button from "../../../components/button";

function RegistrosComponent() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleBackClick = () => {
    navigate(-1);
  };

  const [users, setUsers] = useState([]);
  const [soloUnDia, setSoloUnDia] = useState(true);

  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const response = await dispatch(getAllUsers());

        setUsers(response);

      } catch (error) {
        console.error("Error al cargar los usuarios:", error);
      }
    };
    fetchUsers();
  }, [dispatch]);


  const {
    register,
    unregister,
    handleSubmit,
    getValues,
    reset,
    setValue,
    watch,
    formState: { errors },
  } = useForm();

  const estadoSeleccionado = watch("estado", "todos");
  // Definir los mensajes según el estado seleccionado
  const estadoMensajes = {
    Egresado: "Se filtrará los vehículos que egresaron en la fecha seleccionada",
    Compactado: "Se filtrará los vehículos que se compactaron en la fecha seleccionada",
    default: "Se filtrará los vehículos que ingresaron en la fecha seleccionada",
  };

  const mensajeEstado = estadoMensajes[estadoSeleccionado] || estadoMensajes.default;

  const handleCheckboxChange = () => {
    if (soloUnDia) {
      unregister("date"); // Elimina "date" si cambia a rango
      setValue("endDate", new Date().toISOString().split("T")[0]);
      setValue("startDate", "");
    } else {
      unregister("startDate"); // Elimina "startDate" si cambia a solo un día
      setValue("endDate", "");
      unregister("endDate"); // También elimina "endDate"
      setValue("date", new Date().toISOString().split("T")[0]);
    }
    setSoloUnDia(!soloUnDia);
  };

  const [registro, setRegistro] = useState([]);
  const [submit, setSubmit] = useState(false);

  const [loading, setLoading] = useState(false);

  const onSubmit = async (data) => {
    setLoading(true);
    const response = await dispatch(getRegistro(data));
    setRegistro(response);
    setSubmit(true)
    setLoading(false)
  };

  const handleResetFilters = () => {
    reset(); // Restablece todos los campos del formulario
    setRegistro([]); // Limpia los registros filtrados
    setSubmit(false); // Indica que no se ha hecho un filtro aún
  };

  return (
    <div className="bg-[#F5FAFF]">
      <Navbar />

      <button
        onClick={handleBackClick}
        className="z-50 sm:absolute sm:mt-[2.5rem] mt-[1rem] sm:ml-[5rem] lg:ml-[13rem] ml-[3rem] flex items-center justify-center p-2 rounded-full hover:drop-shadow-[3px_3px_5px_rgba(0,0,0,0.3)] transition ease-in-out duration-200"
      >
        <ActionCircleIcon className="flex flex-start h-12 drop-shadow-[2px_2px_4px_rgba(0,0,0,0.3)]" />
      </button>


      <div className="flex min-h-screen flex-col  items-center bg-[#F5FAFF] gap-8">
        <div class="flex flex-col justify-center items-start sm:items-center mt-[1rem] sm:mt-[1rem] w-[21rem] sm:w-[32rem]">
          <div class="text-[#3d4245] sm:text-[2rem] text-[1rem] font-bold font-inter">
            Tabla de registros
          </div>
          <div class="text-[#687073] sm:text-[1.1rem] text-s font-medium font-inter">
            Movimientos dentro de la plataforma
          </div>
        </div>

        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="flex flex-col justify-center items-start w-[21rem] sm:w-[40rem] p-4 bg-white rounded-lg shadow-[1px_2px_8px_1px_rgba(220,220,220,0.45)] overflow-hidden">

            {/* Checkbox: Un solo día */}
            <div className="flex items-center col-span-2">
              <input
                type="checkbox"
                id="soloUnDia"
                checked={soloUnDia}
                onChange={handleCheckboxChange}
                className="mr-2 cursor-pointer  w-6 h-6 rounded border-2 border-[#0477ad] bg-white focus:outline-none focus:ring-0"
              />
              <label htmlFor="soloUnDia" className="text-sm text-[#3d4245] font-inter cursor-pointer">
                Solo un dia
              </label>
            </div>


            <div className="self-stretch flex-col items-start gap-5 flex">


              <div className="grid grid-cols-2 gap-2 w-full">

                {/* Fechas */}
                <div className="flex flex-col gap-1">
                  {!soloUnDia ? (<div className="text-[#3d4245] text-sm font-normal font-inter">Desde</div>
                  ) : (<div className="text-[#3d4245] text-sm font-normal font-inter">Fecha</div>)}
                  <input
                    name={soloUnDia ? "date" : "startDate"}
                    type="date"
                    className="w-full text-sm font-inter rounded-md p-2"
                    defaultValue={soloUnDia ? new Date().toISOString().split("T")[0] : ""} //No se actualiza dinamicamente con el checkbox
                    {...register(soloUnDia ? "date" : "startDate", {
                      required: "Por favor, ingrese la fecha desde la que desea filtrar",
                      validate: (value) => {
                        const selectedDate = new Date(value);
                        const now = new Date();
                        if (selectedDate > now) {
                          return "La fecha no puede ser superior a la actual";
                        }
                        return true;
                      },
                    })}
                  />
                </div>

                <div className="flex flex-col gap-1 justify-end">
                  {!soloUnDia && <div className="text-[#3d4245] text-sm font-normal font-inter">Hasta</div>}
                  <input
                    disabled={soloUnDia}
                    name="endDate"
                    type="date"
                    /* defaultValue={!soloUnDia ? new Date().toISOString().split("T")[0] : ""} */  //No se actualiza dinamicamente con el checkbox
                    className={`w-full text-sm font-inter rounded-md p-2 ${soloUnDia ? "bg-gray-300 cursor-not-allowed" : ""
                      }`}
                    {...register("endDate", {
                      validate: (value) => {
                        const selectedDate = new Date(value);
                        const now = new Date();
                        const startDate = new Date(getValues("startDate"));
                        if (selectedDate > now) {
                          return "La fecha no puede ser superior a la actual";
                        }
                        if (selectedDate <= startDate) {
                          return "La fecha final debe ser mayor a la fecha de inicio";
                        }
                        return true;
                      },
                    })}
                  />
                </div>


                {/* Estado */}
                <div className="flex flex-col gap-1">
                  <div className="text-[#3d4245] text-sm font-inter">Estado</div>
                  <select
                    className="w-full text-sm font-inter rounded-md p-2"
                    defaultValue="todos"
                    {...register("estado")}
                  >
                    <option value="todos">Todos</option>
                    <option value="Egresado">Egresados</option>
                    <option value="Compactado">Compactados</option>
                    <option value="Ingresado">Ingresados</option>
                    <option value="No Compactar">No compactar</option>
                    <option value="A compactar">A compactar</option>
                    <option value="Desconocido">Desconocido</option>
                  </select>
                </div>

                {/* Usuario */}
                <div className="flex flex-col gap-1">
                  <div className="text-[#3d4245] text-sm font-inter">Usuario</div>
                  <select
                    className="w-full text-sm font-inter rounded-md p-2"
                    defaultValue="todos"
                    {...register("user")}
                  >
                    <option value="todos">Todos</option>
                    {users?.map((user, index) => (
                      <option key={index} value={user.id}>
                        {user.nombreCompleto}
                      </option>
                    ))}
                  </select>
                </div>


                {/* Tipo de vehículo */}
                <div className="flex flex-col gap-1">
                  <div className="text-[#3d4245] text-sm font-inter">Tipo de vehículo</div>
                  <select
                    className="w-full text-sm font-inter rounded-md p-2"
                    defaultValue="todos"
                    {...register("tipovh")}
                  >
                    <option value="todos">Todos</option>
                    <option value="Automóvil">Automóvil</option>
                    <option value="Moto">Moto</option>
                    <option value="Otro">Otro</option>
                  </select>
                </div>

                {/* Sector */}
                <div className="flex flex-col gap-1">
                  <div className="text-[#3d4245] text-sm font-inter">Sector</div>
                  <select
                    className="w-full text-sm font-inter rounded-md p-2"
                    defaultValue=""
                    {...register("sector", { required: "Ingrese un sector por favor" })}
                  >
                    <option value="todos">Todos</option>
                    {Array.from({ length: 26 }, (_, i) => {
                      const letter = String.fromCharCode(65 + i);
                      return (
                        <option key={letter} value={letter}>
                          {letter}
                        </option>
                      );
                    })}
                  </select>
                </div>
              </div>


              <div className="self-stretch justify-start items-start gap-2 inline-flex">
                <Button
                  type="submit"
                  size="lg"
                  loading={loading}
                  disabled={loading}
                  className="grow shrink basis-0"
                >
                  Filtrar
                </Button>

                <Button
                  type="button"
                  variant="secondary"
                  size="lg"
                  onClick={handleResetFilters}
                  className="grow shrink basis-0"
                >
                  Limpiar filtros
                </Button>
              </div>
            </div>

            <p className="text-green-500 mt-2">{mensajeEstado}</p>

            {Object.values(errors).map((error, index) => (
              <p className="text-red-500 mt-4" key={index}>
                {error.message}
              </p>
            ))}
          </div>
        </form>
        {submit ? <RegistroTableComponent registro={registro} /> : ""}
      </div >
    </div >
  );
}

export default RegistrosComponent;
